import React from 'react';
import IconGlyph from './IconGlyph';
import { getRateSeparatorColors } from '../utils/rateSeparatorUtil';
import '../css/RateSeparatorPill.css';

/**
 * The label on a rate separator in the guest time slot grid — e.g.
 * "☀ DAY RATE · ₱250/hr · 5:00 AM – 4:00 PM". Also drawn as the live preview
 * beside each rate in Config -> Sports & Courts -> Hourly rates.
 *
 * Takes the band's own icon and background colour when set; without a colour
 * it uses the club's accent (Config -> Theme), so it always fits the palette.
 *
 * @param {object} props
 * @param {string} [props.name] - the band's name, shown first in capitals
 * @param {string} [props.icon] - emoji or Iconify id
 * @param {string} [props.color] - background hex
 * @param {string} [props.price] - formatted price text, e.g. "₱250/hr"
 * @param {string} [props.hours] - formatted hours, e.g. "5:00 AM – 4:00 PM"
 * @returns {JSX.Element}
 */
function RateSeparatorPill({ name, icon, color, price, hours }) {
  const colors = getRateSeparatorColors(color);
  const parts = [price, hours].filter(Boolean);

  return (
    <span className={`rsp-pill${colors ? ' rsp-custom' : ''}`} style={colors || undefined}>
      {icon && <IconGlyph icon={icon} className="rsp-icon" />}
      {name && <span className="rsp-name">{name}</span>}
      {parts.map((part, index) => (
        <React.Fragment key={`${index}-${part}`}>
          {(name || index > 0) && <span className="rsp-dot" aria-hidden="true">·</span>}
          <span className="rsp-detail">{part}</span>
        </React.Fragment>
      ))}
    </span>
  );
}

export default RateSeparatorPill;
